import { CheckboxControl, useFormatDate, useFormatDateTime } from "@dgs/core";
import { FC } from "react";
import { DataFieldOption, DataFieldType, DataFieldWithOptionContingentCheckResource } from "../shared/types";
import { getFilenameFromPath, isExistingFile, isNewFile } from "./RegistrationFormFileField";
import { Value } from "./Value";

const noop = () => Promise.resolve();

interface Props {
	dataField: DataFieldWithOptionContingentCheckResource;
	value: number | string | number[] | boolean | File | undefined | null | DataFieldOption[];
	error?: string;
}

export const DataFieldValueRenderer: FC<Props> = ({ value, dataField, error }) => {
	const formatDate = useFormatDate();
	const formatDateTime = useFormatDateTime();

	if (value === null || value === undefined) {
		return <Value error={error} />;
	}

	switch (dataField.type) {
		case DataFieldType.CHECKBOX:
			return (
				<CheckboxControl
					name={`${dataField.id}`}
					disabled
					value={value as boolean}
					label={""}
					onChange={noop}
					error={error}
				/>
			);
		case DataFieldType.SELECT_FIELD: {
			const selectedOption = dataField.options.find((x) => x.id === value)?.value;
			return <Value error={error} value={selectedOption} />;
		}
		case DataFieldType.RADIO: {
			const selectedOption = dataField.options.find((x) => x.id === parseInt(value as string, 10))?.value;
			return <Value error={error} value={selectedOption} />;
		}
		case DataFieldType.MULTI_SELECT_FIELD:
		case DataFieldType.CHECKBOX_GROUP: {
			const selectedOptions = dataField.options
				.filter((x) => (value as number[]).includes(x.id))
				.map((x) => x.value)
				.join(", ");
			return <Value error={error} value={selectedOptions} />;
		}
		case DataFieldType.DATE: {
			return <Value error={error} value={formatDate(value as string)} />;
		}
		case DataFieldType.LOCAL_DATETIME:
		case DataFieldType.DATETIME: {
			return <Value error={error} value={formatDateTime(value as string)} />;
		}
		case DataFieldType.CRYPT:
			return <Value error={error} value="***********" />;
		case DataFieldType.FILE: {
			const myValue = value as File | string;
			if (!myValue) {
				return <Value error={error} />;
			}
			if (isNewFile(myValue)) {
				return <Value error={error} value={myValue.name} />;
			}
			if (isExistingFile(myValue)) {
				return <Value error={error} value={getFilenameFromPath(myValue)} />;
			}
			return <Value error={error} />;
		}
		default:
			return <Value error={error} value={value as number | string} />;
	}
};
